<form [formGroup]="form.formGroup">

  <div class="flex flex-col space-y-2">

    @if (
      operationType !== 'runCasingAndCirculate' &&
      operationType !== 'drilling' &&
      operationType !== 'tripPipeAndCirculate'
    ) {
      <div class="flex flex-col">
        <label for="pipeRoughness">Pipe Roughness</label>
        <app-validated-number-input
          [id]="'pipeRoughness'"
          [control]="control('pipeRoughness')"
          [value]="control('pipeRoughness').value"
          [validation]="pipeRoughnessValidation"
          [unit]="userUnits.shortLengths"
          [unitPrecisionOverrides]="{ 'in': 6, 'cm': 5, 'mm':4 }"
        ></app-validated-number-input>
      </div>
    }

    <div class="flex flex-col">
      <label for="waterMudFlowRate">
        {{ operationType === 'runCasingAndCirculate' || operationType === 'tripPipeAndCirculate' ? 'Circulation Rate' : 'Flow Rate' }}
      </label>
      <app-validated-number-input
        [id]="'flowRate'"
        [control]="control('flowRate')"
        [value]="control('flowRate').value"
        [validation]="flowRateValidation"
        [unit]="flowUnit"
      ></app-validated-number-input>
    </div>
  </div>

</form>